import LoginForm from 'components/LoginForm/LoginForm';
import { useNavigate } from 'react-router-dom';

import styles from './LoginPage.module.css';
import { useCallback, useState, useEffect } from 'react';
import { useLanguageService } from 'translations';
import { useUser } from 'components/UserProvider/UserProvider';
import auth from 'services/auth';

const DEFAULT_THEME = 'brand2';

function LoginPage() {
  if (!localStorage.getItem('prefers-color-theme')) {
    localStorage.setItem('prefers-color-theme', DEFAULT_THEME);
  }
  const currentThemeName = localStorage.getItem('prefers-color-theme');
  document.body.setAttribute('data-theme-name', currentThemeName);
  const { user } = useUser();

  const onFormDataChange = useCallback(() => {
    setError('');
  }, []);

  const { t, isRtl } = useLanguageService();
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { setIsAuthPending } = useUser();

  useEffect(() => {
    if (user) navigate('/');
  }, [user, navigate])

  const login = useCallback(
    async (data) => {
      try {
        const res = await auth.login(data);
        if (!res) {
          setError(t('LoginError'));
        }
        if (res.code) {
          setError(res.message);
        } else {
          localStorage.setItem('token', res.authToken);
          setIsAuthPending(true);
          navigate('/');
        }
      } catch (e) {
        setError(t('LoginError'));
      }
    },
    [navigate, setIsAuthPending, t],
  );

  return (
    <div className={styles.container} dir={isRtl ? 'rtl': 'ltr'}>
      <LoginForm login={login} error={error} onChange={onFormDataChange} />
    </div>
  );
}

export default LoginPage;
